import React from 'react';
import { Button, Modal, SparkIcon, SparkModalPortal } from '@spark';
import { DataSelection } from '@/pages/DataSelection';
import {
    DATA_EDITOR_BACK_LABEL,
    DATA_EDITOR_SAVE_LABEL,
    DATA_EDITOR_TITLE,
} from './reviewOverview';

/**
 * Data Editor over Review Training Plan. The body is the existing editor
 * (Train / Benchmark / Archive, label editing, Reviewed column). Both footer
 * buttons, the back chevron, and the close icon return to the review modal.
 * Row edits already saved through the record APIs stay saved.
 */
const WizardDataEditorModal = ({ open, onClose, moveToScreen }) => (
    <SparkModalPortal
        open={open}
        onClose={onClose}
        size="wide"
        destroyOnClose
        className="cw-review-editor-portal"
    >
        <Modal
            title={
                <span className="cw-review-editor-title">
                    <Button
                        variant="ghost"
                        size="small"
                        type="button"
                        aria-label="Back to review"
                        iconSlug="arrow-left"
                        startIcon={<SparkIcon slug="arrow-left" size="small" />}
                        onClick={onClose}
                    />
                    {DATA_EDITOR_TITLE}
                </span>
            }
            showSubtitle={false}
            className="cw-review-editor-modal"
            primaryLabel={DATA_EDITOR_SAVE_LABEL}
            tertiaryLabel={DATA_EDITOR_BACK_LABEL}
            onPrimaryClick={onClose}
            onTertiaryClick={onClose}
            onCloseClick={onClose}
        >
            {open ? (
                <DataSelection embeddedInTaskDrawer topTabs moveToScreen={moveToScreen} />
            ) : null}
        </Modal>
    </SparkModalPortal>
);

export default WizardDataEditorModal;
